import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

interface TransportType {
  id: number;
  name: string;
  abbreviation: string;
}

export const useTransportTypes = () => {
  const [transportTypes, setTransportTypes] = useState<TransportType[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTransportTypes = async () => {
      try {
        const { data, error } = await supabase
          .from('booking_transport_types')
          .select('id, name, abbreviation')
          .order('name');

        if (error) throw error;
        setTransportTypes((data || []).map(item => ({
          id: item.id,
          name: item.name,
          abbreviation: item.abbreviation || ''
        })));
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch transport types');
      } finally {
        setLoading(false);
      }
    };

    fetchTransportTypes();
  }, []);

  return { transportTypes, loading, error };
};